/**
 * Tracking Module Definition
 *
 * Modified Date: 4/28/14 by ML @ 2:19PM
 *
 * Communications Platform / VPTrack / Omniture Tracking
 *
 */

define(['StandardModule', 'json2', 'Util', 'md5', 'Heartbeat'], function (parentModel, Json2, Util, md5, Heartbeat) { //replace the standardmodule with the module you are extending
	function _thisObject_(o) {
		var defaults = {
			type: 'tracking', //name your module, use this file's exact filename w/o the .js.
			author: 'ML', //your name if you are the original writer
			lasteditby: '',
			omnitureEnable: true,
			cpEnable: true, //enables checking for 'data-cp' tag attribute, to pick up page-level CP vars,
			ippEnable: false, //enables checking for 'data-ipp' tag attribute, to pick up page-level IPP vars
			vptrackEnable: true, //enables initialization of vpTrack iframe on load
			cpObj: {}, //object variable to store page-level CP vars
			ippObj: {}, //object variable to store page-level CP vars
			vpUrl: window.location.href.split('?')[0].split('#')[0].replace(/\/$/, ''), //default vpTrack URL points to window location
			omniPagenameDefault: window.location.href.split('://')[1].split('?')[0].split("#")[0].replace('www.',''),
			pamProductName: '',
			pamHashArray: [],
			iOsDropOffFlag: false,
			appRequestCSD: false,
			appDropOff: false
		};
		defaults = $.extend(defaults, o);
		parentModel.call(this, defaults);
		return (this);
	};
	_thisObject_.prototype = Object.create(parentModel.prototype);

	//DEFINE LISTENERS HERE
	_thisObject_.prototype._startlisteners = function () {
        this.notify('Trace', '_startlisteners');
        var self = this;
        var myID = this._id();
        _notify.add(this._id(), function() {
            return {
				onTrackBind: function(param) {
					var activeFunc = eval('self.' + param.data[0]);
					param.data.shift();
					activeFunc.apply(self, param.data);
                },
				onPageNamePAM: function(param) {
					s_md.pageName = document.domain.replace('wp.','').replace(/www\.(.+\.com)/,'$1') + '/' + self._var().pamProductName + '/' + self._var().ippObj.sfNum + '/' + md5(self._var().ippObj.sfNum + '_' + param.data) + '/';
					self._var().omniPagenameDefault = document.domain.replace('wp.', '').replace(/www\.(.+\.com)/,'$1') + '/' + self._var().pamProductName + '/' + self._var().ippObj.sfNum + '/' + md5(self._var().ippObj.sfNum + '_' + param.data) + '/';
                }
            };
        }());
	};

	// MODULE METHODS - you should always have init/refresh/kill defined!

	_thisObject_.prototype.init = function() {
		this.notify('Trace', 'init');
		this._startlisteners(); //start this module's listeners
		this.refresh();
		this.getCpObj();
		if (this._var().ippEnable) {
			this.getIppObj();
			if (!window.medscape.core.isApp) {
				this.cp({'appname':'ippevent', 'activityName':'requestCSD'});
				this.bindDropoff();
			}
			else {
				if (this._var().appRequestCSD) {
					this.cp({'appname':'ippevent', 'activityName':'requestCSD'});
				}
				if (this._var().appDropOff) {
					//this.bindDropoff();  remove ipp dropoff tracking for App - PPE45854
				}
			}
		}
		this.vpTrackInit();
		this.getBindings();
	};

	_thisObject_.prototype.refresh = function () {
		this.notify('Trace', 'refresh');
	};

	_thisObject_.prototype.kill = function () {
		this.notify('Trace', 'kill');
		_notify.rem(this._id()); //kills this module's listeners
	};

	// UNIQUE MODULE METHODS

	_thisObject_.prototype.getBindings = function () { // pick up element function bindings
		try {
			var self = this;
			$('*[data-track]').each(function() {
				if ($.trim($(this).attr('data-track')) != '' && typeof $(this).attr('data-event') == 'undefined') { // if data-track not blank and data-event not specified, fire all defined functions contained within attribute
					var funcArr = $(this).attr('data-track').replace(/ /g,'').split(';');
					for (x = 0; x < funcArr.length; x++) {
						try {
							if (typeof eval('self.' + funcArr[x].split('(')[0]) == "function") {
								if (funcArr[x].split('(')[0] == "pamTrack") {
									eval('self.pamHash(' + funcArr[x].split('(')[1].split(')')[0] + ',this)');
								}
								eval('self.' + funcArr[x].split(')')[0] + ',this)');
							}
						}
						catch(err) {
						}
					}
				}
				else if ($.trim($(this).attr('data-track')) != '' && typeof $(this).attr('data-event') != 'undefined') { // else if data-event specified, bind function call to events
					var funcArr = $(this).attr('data-track').replace(/ /g,'').split(';');
					for (x = 0; x < funcArr.length; x++) {
						try {
								if (typeof eval('self.' + funcArr[x].split('(')[0]) == "function") {
									var params = funcArr[x].split("('")[1].split("')")[0];

									if (funcArr[x].split('(')[0] == "pamTrack") {
										eval('self.pamHash(' + params + ',this)');
									}
									var paramsArr = params.split("','");
									paramsArr.splice(0, 0, funcArr[x].split('(')[0]);
									paramsArr.push(this);
									$(this).on($(this).attr('data-event').replace(","," "), function() {self.notify('TrackBind',paramsArr.slice(0))});
								}
						}
						catch(err) {
						}
					}
				}
			});
		}
		catch (err)
		{
			console.log(err);
		}
	}

	_thisObject_.prototype.cp = function(name, obj) { // CP object variable setup function + call fire
		try {
			var self = this;
			if (self._var().cpEnable)
			{
				var cpObjTemp = {};
				if ($('[data-cp]').length > 1 && typeof obj != 'undefined') {
					try {
						cpObjTemp = JSON.parse($(obj).parents().has('[data-cp]').first().children('[data-cp]:eq(0)').attr('data-cp'));
					}
					catch(err) {
						self.notify('Trace', '\"data-cp\" meta tag not well-formed/parseable, please check formatting for proper tracking. Err: ' + err);
					}
				}
				else {
					cpObjTemp = self._var().cpObj;
				}
				if (typeof name == 'object')
				{
					$.extend(cpObjTemp, name);
				}
				else
				{
					cpObjTemp.activityName = name;
				}
				self.postCp(cpObjTemp);
			}
		}
		catch (err)
		{
			console.log(err);
		}
	}

	_thisObject_.prototype.getCpObj = function() { // Pick up page-level CP attributes
		if (this._var().cpEnable)
		{
			if ($('[data-cp]').length > 0) {
				try {
					this._var().cpObj = JSON.parse($('[data-cp]:eq(0)').attr('data-cp'));
				}
				catch(err) {
					this.notify('Trace', '\"data-cp\" meta tag not well-formed/parseable, please check formatting for proper tracking. Err: ' + err);
				}
			}
		}
	}

	_thisObject_.prototype.getIppObj = function() { // Pick up page-level CP attributes
		if (this._var().ippEnable)
		{
			if ($('[data-ipp]').length > 0) {
				try {
					this._var().ippObj = JSON.parse($('[data-ipp]:eq(0)').attr('data-ipp'));
				}
				catch(err) {
					this.notify('Trace', '\"data-ipp\" meta tag not well-formed/parseable, please check formatting for proper tracking. Err: ' + err);
				}
			}
		}
	}

    _thisObject_.prototype.trackIpp = function(action) {
			try {
				if (this._var().ippEnable)
				{
					var self = this;
					if (typeof self._var().ippObj.wpUrl != 'undefined' && typeof self._var().ippObj.parIdE != 'undefined' && typeof self._var().ippObj.activityId != 'undefined')
					{
						var preload_image = new Image(1,1);
						if (typeof self._var().ippObj.tacticId != 'undefined')
						{
							preload_image.src = '//' + self._var().ippObj.wpUrl + '/activity/viewpresentation?action=' + action + '&activityId=' + self._var().ippObj.activityId + '&parId=' + self._var().ippObj.parIdE + '&tacticId=' +  self._var().ippObj.tacticId;
						}
						else
						{
							preload_image.src = '//' + self._var().ippObj.wpUrl + '/activity/viewpresentation?action=' + action + '&activityId=' + self._var().ippObj.activityId + '&parId=' + self._var().ippObj.parIdE;
						}
					}
				}
			}catch(err) {
				console.log(err);
			}
    };

	_thisObject_.prototype.postCp = function(cpdata, callback) { // Master CP call function (directly ported from current version used on site, standalone 'cp.js' file)
		try {
			if (typeof cpdata != 'undefined') {
				if (typeof callback == 'object')
				{
					callback = undefined;
				}
				if (typeof s_registered_user_id != 'undefined' || typeof cpdata.uid != 'undefined') {
					if (typeof cpdata.uid == 'undefined') {
						cpdata.uid = s_registered_user_id;
					}
					if (typeof cpdata.url == 'undefined') {
						cpdata.url = encodeURIComponent(window.location.href.split("?")[0]);
					}
					cpdata.date = new Date().getTime();
					var cpJSON = JSON.stringify(cpdata);
					$.ajax({
						type: "GET",
						contentType: "application/jsonp",
						url: "//api" + Util.envCheck() + ".medscape.com/cp/events.json",
						data: 'event=' + cpJSON,
						dataType: "jsonp",
						timeout: 2000,
						complete: callback
					});
				}
			}
		}
		catch (err)
		{
			console.log(err);
		}
	}

	_thisObject_.prototype.vp = function (trackData, trackUrl) { // main vpTrack function, sets vpTrack iframe SRC to proper URL
		try {
			var self = this;
			if (typeof trackUrl == 'object')
			{
				trackUrl = undefined;
			}
			if (self._var().vptrackEnable)
			{
				var wpCheck = '';
				if (document.domain.match('wp.') != null)
				{
					wpCheck = 'https://www' + Util.envCheck() + '.medscape.com';
				}
				if (typeof trackUrl != 'undefined') {
					$('iframe[id=xmlFrame]').attr('src', wpCheck + '/public/vptrack.wxml?desturl=' + trackUrl + '%5f' + trackData);
				} else {
					$('iframe[id=xmlFrame]').attr('src', wpCheck + '/public/vptrack.wxml?desturl=' + self._var().vpUrl + '%5f' + trackData);
				}
			}
		}
		catch (err)
		{
			console.log(err);
		}
	}

	_thisObject_.prototype.vpTrackInit = function() { // check if vpTrack iframe pre-exists on page, creates it if necessary. Sets vpTrack url to 'canonical' URL if present.
		try {
			if (this._var().vptrackEnable) {
				if ($('iframe[id=xmlFrame]').length == 0 && document.domain.match('wp.') == null) {
					$('body').append('<iframe height="0" width="0" name="xmlFrame" id="xmlFrame" src="/public/vptrack_iframe.html" style="display: none;"></iframe>');
				}
				else if ($('iframe[id=xmlFrame]').length == 0 && document.domain.match('wp.') != null) {
					$('body').append('<iframe height="0" width="0" name="xmlFrame" id="xmlFrame" src="https://www' + Util.envCheck() + '.medscape.com/public/vptrack_iframe.html" style="display: none;"></iframe>');
				}
			}
			if ($('link[rel=canonical]').length > 0 && $.trim($('link[rel=canonical]:eq(0)').attr('href')) != '') {
				this._var().vpUrl = $.trim($('link[rel=canonical]:eq(0)').attr('href'));
			}
		}
		catch (err)
		{
			console.log(err);
		}
	}

	_thisObject_.prototype.omni = function (sLink, pName, obj) { // Omniture Ad Hoc tracking, for Internal or External-Domain destinations
		try {
			var self = this;
			if (typeof pName == 'object')
			{
				obj = pName;
				pName = undefined;
			}
			if (self._var().omnitureEnable) {
				if (typeof obj != 'undefined' && typeof obj == 'object') {

					if (typeof obj.href != 'undefined') { // if referring element link points to external domain, fire external Omniture function
						if ((obj.href.match(/:\/\//) != null && obj.href.match(/:\/\/[^\/]+\//)[0].split('/')[2] != document.domain) || $.trim(obj.href) == window.location.href.split('#')[0] + "#") {
							self.omniPageLink(sLink, pName);
						}
						else { // else fire internal Omniture function
							self.omniTrack(sLink, pName);
						}
					}
					else if (typeof obj.action != 'undefined') { // if referring element form action points to external domain, fire external Omniture function
						if ((obj.action.match(/:\/\//) != null && obj.action.match(/:\/\/[^\/]+\//)[0].split('/')[2] != document.domain) || $.trim(obj.action) == window.location.href.split('#')[0] + "#") {
							self.omniPageLink(sLink, pName);
						}
						else { // else fire internal Omniture function
							self.omniTrack(sLink, pName);
						}
					}
					else {
						self.omniPageLink(sLink, pName);
					}
				}
				else {
					self.omniPageLink(sLink, pName);
				}
			}
		}
		catch (err)
		{
			console.log(err);
		}
	};

	_thisObject_.prototype.omniTrack = function (sLink, pName) { // Omniture Ad Hoc tracking, for In-Domain destinations
		try {
			if (this._var().omnitureEnable) {
				if (typeof pName == 'object')
				{
					pName = undefined;
				}
				if (typeof wmdTrack != 'undefined') {
						if (typeof pName != 'undefined')
						{
							s_md.pageName = pName;
						}
						wmdTrack(sLink);
						if (typeof pName != 'undefined') {
							s_md.pageName = this._var().omniPagenameDefault;
						}
				}
			}
		}
		catch (err)
		{
			console.log(err);
		}
	};

	_thisObject_.prototype.omniPageLink = function(sLink, pName) { // Omniture Ad Hoc tracking, for External-Domain destinations
		try {
			if (this._var().omnitureEnable) {
				if (typeof pName == 'object')
				{
					pName = undefined;
				}
				if (typeof wmdPageLink != 'undefined') {
						if (typeof pName != 'undefined')
						{
							s_md.pageName = pName;
						}
						wmdPageLink(sLink);
						if (typeof pName != 'undefined') {
							s_md.pageName = this._var().omniPagenameDefault;
						}
				}
			}
		}
		catch (err)
		{
			console.log(err);
		}
	};

	_thisObject_.prototype.omniPageview = function(pCount, pName) { // Omniture Page View function
		try {
			if (this._var().omnitureEnable) {
				if(typeof pName == 'object')
				{
					pName = undefined;
				}
				if(typeof wmdPageview != 'undefined') {
					if (typeof pName != 'undefined') {
							wmdPageview(pName, pCount);
					}
					else {
							wmdPageview("", pCount);
					}
					if (typeof pName != 'undefined') {
						s_md.pageName = this._var().omniPagenameDefault;
					}
				}
			}
		}
		catch (err)
		{
			console.log(err);
		}
	};

	_thisObject_.prototype.segVarPop = function(obj) {
		try {
        if ($("meta[name=metasegvar]").length > 0) {
               if (segVarParam("artid") != '0') obj.activityId = segVarParam('artid');
               if (segVarParam("ssp") != '0') obj.leadSpec = segVarParam('ssp');
               if (segVarParam("scg") != '0') obj.leadConcept = segVarParam('scg');
			   if (segVarParam("cg") != '0') obj.contentGroup = segVarParam('cg');
                    if (segVarParam('bc') != '__') {
                            var bcTemp = segVarParam('bc');
                            bcTemp = bcTemp.substring(1, bcTemp.length - 1);
                            bcTemp = bcTemp.split("_");
                            obj.blockCode = bcTemp;
                        }
                    }
		}
		catch (err)
		{
			console.log(err);
		}
     };

	_thisObject_.prototype.socialCp = function (platform) {
		try {
			if (this._var().cpEnable)
			{
				var cpSocData = new Object();
				cpSocData.appname = 'social-functions';
				cpSocData.activityName = encodeURIComponent(platform);
				this.segVarPop(cpSocData);
				this.postCp(cpSocData);
			}
		}
		catch (err)
		{
			console.log(err);
		}
    };

	_thisObject_.prototype.cpArticleLoad = function (appname) {
		try {
			if (this._var().cpEnable)
			{
				var cpArticle = {};
				var testPagination;
				this.segVarPop(cpArticle);
				cpArticle.appname = appname;
				cpArticle.activityName = 'view';
				if (cpArticle.appname === 'viewarticle') {
					testPagination = window.location.pathname.match(/\/viewarticle\/\d+_\d+/);
					if (testPagination !== null) {
						cpArticle.pageN = window.location.pathname.match(/\/viewarticle\/\d+_\d+/)[0].split('_')[1];
					} else {
						cpArticle.pageN = 1;
					}
				}
				this.postCp(cpArticle);
			}
		}
		catch (err)
		{
			console.log(err);
		}
	};

	//Function to Send Track, or Bind to Elements
	_thisObject_.prototype.pamTrack = function (assetName, moduleStrOrPvNum, element) {
		try {
			var self = this;
			if (typeof element == 'object') {
				if (typeof moduleStrOrPvNum == 'number'){
					this.omniPageview(moduleStrOrPvNum, document.domain.replace('wp.','').replace(/www\.(.+\.com)/,'$1') + '/' + this._var().pamProductName + '/' + this._var().ippObj.sfNum + '/' + md5(this._var().ippObj.sfNum + '_' + assetName) + '/', element);
				}
				else {
					this.omni(moduleStrOrPvNum, document.domain.replace('wp.','').replace(/www\.(.+\.com)/,'$1') + '/' + this._var().pamProductName + '/' + this._var().ippObj.sfNum + '/' + md5(this._var().ippObj.sfNum + '_' + assetName) + '/', element);
				}
			}
			else {
				if (typeof moduleStrOrPvNum == 'number'){
					this.omniPageview(moduleStrOrPvNum, document.domain.replace('wp.','').replace(/www\.(.+\.com)/,'$1') + '/' + this._var().pamProductName + '/' + this._var().ippObj.sfNum + '/' + md5(this._var().ippObj.sfNum + '_' + assetName) + '/');
				}
				else {
					this.omni(moduleStrOrPvNum, document.domain.replace('wp.','').replace(/www\.(.+\.com)/,'$1') + '/' + this._var().pamProductName + '/' + this._var().ippObj.sfNum + '/' + md5(this._var().ippObj.sfNum + '_' + assetName) + '/');
				}
			}
		}
		catch (err)
		{
			console.log(err);
		}
	};

	_thisObject_.prototype.pamHash = function (assetName, moduleStrOrPvNum, element, optNum) {
		try {
			if (typeof element != 'undefined') {
				if (typeof element == 'number') { // If Element is undefined, but optNum is, fix parameters
					optNum = element;
					element = undefined;
				}
			}

			var itemText = "N/A";

			if (typeof element != 'undefined') {
				if (typeof element.tagName != 'undefined') {
					if (element.tagName.toLowerCase() == "a" || element.tagName.toLowerCase() == "li") {
						if (element.tagName.toLowerCase() == "a" || element.tagName.toLowerCase() == "li") {
							itemText = element.innerHTML;
						}
					}
				}
			}

			if (typeof optNum == 'number') {
				for (x=1; x<=optNum; x++) {
					if (typeof moduleStrOrPvNum == 'number') {
						if ($.inArray('<tr><td>' + this._var().ippObj.sfNum + '_' + assetName + x +  '</td><td>' + md5(this._var().ippObj.sfNum  + '_' + assetName + x) + '</td><td>N/A</td><td>' + itemText + '</td></tr>', this._var().pamHashArray) == -1) {
							this._var().pamHashArray.push('<tr><td>' + this._var().ippObj.sfNum + '_' + assetName + x +  '</td><td>' + md5(this._var().ippObj.sfNum  + '_' + assetName + x) + '</td><td>N/A</td><td>' + itemText + '</td></tr>');
						}
					} else {
						if ($.inArray('<tr><td>' + this._var().ippObj.sfNum + '_' + assetName + x + '</td><td>' + md5(this._var().ippObj.sfNum  + '_' + assetName + x) + '</td><td>' + moduleStrOrPvNum + x + '</td><td>' + itemText + '</td></tr>', this._var().pamHashArray) == -1) {
							this._var().pamHashArray.push('<tr><td>' + this._var().ippObj.sfNum + '_' + assetName + x + '</td><td>' + md5(this._var().ippObj.sfNum  + '_' + assetName + x) + '</td><td>' + moduleStrOrPvNum + x + '</td><td>' + itemText + '</td></tr>');
						}
					}
				}
			} else {
				if (typeof moduleStrOrPvNum == 'number'){
					if ($.inArray('<tr><td>' + this._var().ippObj.sfNum + '_' + assetName +  '</td><td>' + md5(this._var().ippObj.sfNum  + '_' + assetName) + '</td><td>N/A</td><td>' + itemText + '</td></tr>', this._var().pamHashArray) == -1) {
						this._var().pamHashArray.push('<tr><td>' + this._var().ippObj.sfNum + '_' + assetName +  '</td><td>' + md5(this._var().ippObj.sfNum  + '_' + assetName) + '</td><td>N/A</td><td>' + itemText + '</td></tr>');
					}
				} else {
					if ($.inArray('<tr><td>' + this._var().ippObj.sfNum + '_' + assetName + '</td><td>' + md5(this._var().ippObj.sfNum  + '_' + assetName) + '</td><td>' + moduleStrOrPvNum + '</td><td>' + itemText + '</td></tr>', this._var().pamHashArray) == -1) {
						this._var().pamHashArray.push('<tr><td>' + this._var().ippObj.sfNum + '_' + assetName + '</td><td>' + md5(this._var().ippObj.sfNum  + '_' + assetName) + '</td><td>' + moduleStrOrPvNum + '</td><td>' + itemText + '</td></tr>');
					}
				}
			}
		}
		catch (err)
		{
			console.log(err);
		}
	};

	_thisObject_.prototype.pamTrackBind = function(selector, event, assetName, moduleStrOrPvNum) {
		try {
			var self = this;
			$(selector).each(function(idx) {
				$(this).on(event, function() {
					self.notify('TrackBind',['pamTrack', assetName, moduleStrOrPvNum, this]);
				});
				self.pamHash(assetName, moduleStrOrPvNum, this);
			});
		}
		catch (err)
		{
			console.log(err);
		}
	}

	_thisObject_.prototype.getHashTable = function() {

		try {
				var self = this;
				var hashWindow = window.open();
				hashWindow.document.write('<table cellpadding="3" border="1" cellspacing="3">');
				hashWindow.document.write('<tr><th>ASSET</th><th>HASH</th><th>MODULE NAME</th><th>LINK TEXT</th></tr>');
				console.log('pamHashArray', this._var().pamHashArray);
				$(this._var().pamHashArray).each(function() {
					hashWindow.document.write(this);
				});

				hashWindow.document.write('</table>');

				hashWindow.document.close();

		} catch (err) {
			console.log(err);
		}
    };

	_thisObject_.prototype.getRememberMe = function(context, callback) {
		var self = this;
		try {
			if (typeof s_registered_user_id != 'undefined' && typeof self._var().cpObj.activityId != 'undefined') {
				$.ajax({
					type: 'GET',
					contentType: 'application/jsonp',
					url: '//api' + Util.envCheck() + '.medscape.com/cp/ipplastvisit/user/' + Number(s_registered_user_id)/27 + '/activities/' + self._var().cpObj.activityId,
					dataType: 'jsonp',
					timeout: 1000,
					success: function(data) {
						if (typeof data.activities[0].scene != 'undefined') {
							data.activities[0].lastscene = Number(data.activities[0].scene.name.split('scn')[1]);
						}
						data = data.activities[0];
						eval('context.' + callback + '(data)');
					},
					complete: function(data) {
						if (data.readyState != 4) {
							eval('context.' + callback + '({})');
						}
					}
				});
			}
			else {
				eval('context.' + callback + '({})');
			}
		} catch (err) {
			console.log(err);
			eval('context.' + callback + '({})');
		}
    };

    _thisObject_.prototype.trackDropoff = function() {
		try {
			var self = this;
			self.trackIpp('logBrowserClose');
			var tacticId = "";
			if (typeof self._var().ippObj.tacticId != 'undefined')
			{
				tacticId = '"tacticId":"' + self._var().ippObj.tacticId + '",';
			}
			if (typeof s_registered_user_id != 'undefined' && typeof self._var().ippObj.activityId != 'undefined' && typeof self._var().ippObj.parId != 'undefined') {
				var preload_image = new Image(1,1);
				preload_image.src = '//api' + Util.envCheck() + '.medscape.com/cp/events.json?event={' + tacticId + '"activityId":"' + self._var().ippObj.activityId +'","parId":"' + self._var().ippObj.parId + '","appname":"ippevent","activityName":"drop-off","uid":"' + s_registered_user_id + '","url":"' + encodeURIComponent(window.location.href.split("?")[0]) + '","date":' + new Date().getTime() + '}';
			}
			if (navigator.userAgent.toLowerCase().match('chrome') != null)
			{
				return ' ';
			}
		} catch (err)
			{
				console.log(err);
			}
    };

    _thisObject_.prototype.setDropoffFlag = function(event) {
			event.data.context._var().iOsDropOffFlag = true;
    };

    _thisObject_.prototype.bindDropoff = function(param) {
		try {
			var self = this;
			if (typeof param == 'string') {
				var linkSelector = 'a' + param;
			}
			else {
				var linkSelector = 'a';
			}
			if (Util.isMobile() || Util.isIpad()) {
				var bindEvent = 'touchend';
			}
			else {
				var bindEvent = 'click';
			}
			if (navigator.userAgent.toLowerCase().match('iphone') != null || navigator.userAgent.toLowerCase().match('ipad') != null) {
				$(linkSelector).each(function() {
					if (typeof $(this).attr('target') != 'undefined' && $(this).attr('target') == '_blank') {
						if (typeof param == 'string') {
							$(this).off(bindEvent, self.setDropoffFlag);
						}
						$(this).on(bindEvent, {context: self}, self.setDropoffFlag);
					}
				});
				if (typeof param != 'string') {
					$(window).on('pagehide', function() {
						if (self._var().iOsDropOffFlag == false) {
							self.trackDropoff();
						}
					});
					$(window).on('pageshow', function() {
						self._var().iOsDropOffFlag = false;
					});
				}
			}
			else {
				$(window).on('beforeunload', function() {
					self.trackDropoff();
				});
			}
		} catch (err)
			{
				console.log(err);
			}
    };

     _thisObject_.prototype.heartbeatTrack = function(videoModuleInstance) {
		 try {
			if (typeof videoModuleInstance != 'undefined') {
				var hbTemp = new Heartbeat({vidInstance: videoModuleInstance});
				hbTemp.init();
			}

		} catch (err)
			{
				console.log(err);
			}
    };

	//-------------------------------------------------------------------------//

	return (_thisObject_);
});



// WEBPACK FOOTER //
// ./modules/tracking/tracking.js